<template lang="pug">
section.detail-footer
	transition(name="fade")
		.detail-footerScroller(v-if="scrollerVisible", :style="styles.primary.background")
	.detail-footerInner
		app-promo(
			:promotion="promotion",
			:styles="styles",
			:version="'desktop'")

		.detail-footerCost(v-if="priceMask !== null")
			span {{ priceMask }}
			span {{ isNaN(priceMask.replace("$", "")) ? '' : bdrm.PricingText }}

		.detail-footerCost(v-else-if="cost.adjusted <= 0")
			span {{ cost.standard | currency }}
			span {{ bdrm.PricingText }}

		.detail-footerCost.detail-footerCost--reduced(v-else)
			span {{ cost.standard | currency }}
			span {{ cost.adjusted | currency }}
			span {{ bdrm.PricingText }}
			
		.detail-footerApply(v-if="applyURL")
			a.detail-footerApplyLink(
				:href="applyURL", 
				:style="styles.secondary.color", 
				:class="{'is-disabled':availability.AvStatus[0] === 'soldout'}" :data-text="apply" target="_blank")
</template>


<script>
import { gsap } from "gsap"
import Theme from '@/listing-app/mixins/Theme'
import Promo from "@/listing-app/components/detail/Promo.vue"
export default {
	name: "Footer",
	mixins: [Theme],
	props: [
		"availability",
		"priceMask",
		"price",
		"promotion",
		"bdrm",
		"upgrade",
		"term",
		"legacy",
		"salesplan"
	],
	components: {
		appPromo: Promo
	},
  data() {
    return {
      scrollerVisible: true,
      cost: {
        standard: undefined,
        adjusted: undefined
      }
    }
  },
  computed: {
    applyURL() {
			if (this.legacy) {
				return url = document.querySelector("#legacyApplyEndpointURL").value
			}

      let input = document.querySelector("#applyEndpointURL")
      let url = input.getAttribute("value")

      if (url && input.getAttribute("data-append")?.toLowerCase() == "true") {
        url = `${url}&Term=${this.term}&Salesplan=${this.salesplan}`
      }

      return url
    },
    apply() {
      let text
      switch (this.availability.AvStatus[0]) {
        case "waitlist":
          text = "Apply for waitlist"
          break
        default:
          text = "Apply"
          break
      }
      return text
    }
  },
  methods: {
    tween() {
			let price = {...this.price}
			let time = {}

			time.standard = (Math.abs(this.cost.standard - price.standard)*3)/1000
			time.adjusted = (Math.abs(this.cost.adjusted - price.adjusted)*3)/1000

			time.standard = time.standard > .75 ? .75 : time.standard < .25 ? .25 : time.standard
			time.adjusted = time.adjusted > .75 ? .75 : time.adjusted < .25 ? .25 : time.adjusted

			gsap.to(this.cost, { standard: price.standard, duration: time.standard })
			if (price.adjusted && this.cost.adjusted !== 0) {
				gsap.to(this.cost, { adjusted: price.adjusted, duration: time.adjusted })
			}
			else if (this.cost.adjusted === 0) {
				this.cost.adjusted = price.adjusted
			}
			else {
				this.cost.adjusted = 0
			}
    },
    set_scroller_visibility() {
      if (window.pageYOffset > 10) {
        this.scrollerVisible = false
      } else {
        this.scrollerVisible = true
      }
    },
    set_body_padding(e, remove = false) {
      let padding = this.$el.offsetHeight
      if (!remove) {
        document.body.style.paddingBottom = `${padding}px`
      }
      else {
        document.body.style.paddingBottom = ''
      }
    }
  },
  filters: {
    currency(val) {
      return "$" + parseInt(val).toLocaleString()
    }
  },
  updated() {
    this.$emit("updated", this.$el.offsetHeight)
	},
	watch: {
		price() {
			this.tween()
		}
	},
  created() {
    this.tween()
  },
  mounted() {
    this.$emit("updated", this.$el.offsetHeight)
    this.set_scroller_visibility()
    this.set_body_padding(null)
    window.addEventListener("scroll", this.set_scroller_visibility)
    window.addEventListener("resize", this.set_body_padding)
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.set_scroller_visibility)
    window.removeEventListener("resize", this.set_body_padding)
    this.set_body_padding(null, true)
  }
}
</script>


<style lang="scss" <style lang="scss" scoped>
@keyframes scroller {
  0% {
    transform: translateY(3px) rotate(-45deg);
    opacity: 0;
  }
  15% {
    transform: translateY(3px) rotate(-45deg);
    opacity: 1;
  }
  80% {
    transform: translateY(200%) rotate(-45deg);
    opacity: 1;
  }
  100% {
    transform: translateY(200%) rotate(-45deg);
    opacity: 0;
  }
}

.detail-footer {
  z-index: 10;
  position: fixed;
  left: 0;
  right: 0;
  top: 100%;
  background: $white;
  border-top: 1px solid $gray;
  padding: 15px 0;
  display: flex;
  align-items: center;
  transform: translateY(-100%);
  width: 100%;
  min-width: 100%;
  max-width: 100%;
}

.detail-footerScroller {
  height: 40px;
  width: 40px;
  position: absolute;
  bottom: 100%;
  left: 50%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  transform: translateX(-50%);
  opacity: 0.75;
  &:after {
    height: 10px;
    width: 10px;
    border-left: 3px solid $white;
    border-bottom: 3px solid $white;
    transform: rotate(-45deg);
    content: "";
    animation: scroller 1.25s ease infinite;
  }

  &.fade-enter-active,
  &.fade-leave-active {
    transition: opacity 0.25s ease;
  }

  &.fade-enter,
  &.fade-leave-to {
    opacity: 0;
  }
}

.detail-footerInner {
  @include container;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 !important;
  width: 100%;
  height: 100%;
}

.detail-footerCost {
  display: flex;
  flex-direction: column;
  padding-right: 10px;
	font-family: HelveticaNeueW02-57Cn;
  @media (min-width: 991px) {
    margin-left: auto;
    padding-left: 30px;
  }
  span {
    font-size: 12px;
    line-height: 1;
    text-transform: uppercase;
    font-weight: 700;
    white-space: nowrap;
    &:first-child {
      font-size: 26px;
      margin-bottom: 4px;
      text-transform: none;
      @media (min-width: 991px) {
        margin-left: auto;
      }
    }
		&:only-child {
      font-size: 22px;
      text-transform: none;
      @media (min-width: 991px) {
        margin-left: auto;
      }
		}
  }
  &--reduced {
    display: grid;
    grid-template-columns: auto auto;
    grid-template-rows: auto auto;
    grid-gap: 0 5px;
    span {
      &:first-child {
        flex: 0 0 50%;
        font-size: 26px;
        margin-bottom: 4px;
        text-transform: none;
        text-decoration: line-through;
        text-align: right;
        grid-area: 1 / 1 / 2 / 2;
      }
      &:nth-child(2) {
        flex: 0 0 50%;
        font-size: 26px;
        margin-bottom: 4px;
        text-transform: none;
        color: #d11046;
        grid-area: 1 / 2 / 2 / 3;
        @media (min-width: 991px) {
          margin-left: auto;
        }
      }
      &:last-child {
        flex: 0 0 100%;
        grid-area: 2 / 1 / 3 / 3;
      }
    }
  }
}

.detail-footerApply {
  margin-left: 30px;
  .detail-footerApplyLink {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 15px;
    text-align: center;
    background: currentColor;
    transition: 0.25s ease;
    text-transform: uppercase;
    white-space: nowrap;
    border: 4px solid currentColor;
		font-family: $fontFamilyHeadings;
    font-size: 0;
    text-decoration: none;
    &:after {
			content: attr(data-text);
      color: $white;
      font-size: 18px;
			font-weight: 700;
			line-height: 27px;
    	text-decoration: none;
    }
    &:hover {
      text-decoration: none;
      background: $white;
      color: currentColor;
      &:after {
        color: currentColor;
    		text-decoration: none;
      }
    }
    &.is-disabled {
      color: $gray !important;
      pointer-events: none;
    }
  }
}
</style>
